export const en = {
    add_services_title: 'Add services',
    can_execute_title: 'Business trip can be executed',
    add_services_description: 'At least one service must be added for execution',
    can_execute_description: 'After that we will need to approve and execute the added services',
};
